import { sinatraOrigin } from '../../config'

import keycloakService from '../../keycloak_service'

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

const revisedEngineConfig = (engineConfig) => {
  if (!engineConfig.engine || !engineConfig.enginelb || !engineConfig.engineAux) {
    return null
  }
  
  const config = { ...engineConfig }
  config.workspace_id= undefined
  return config
}

export const publishPiplineRequest = (engineConfig, modelConfigIds, pipelineVersionId) => {
  const body = {
    engine_config: revisedEngineConfig(engineConfig),
    model_config_ids: modelConfigIds,
    pipeline_version_id: pipelineVersionId
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  }

  return postToApi('v1/api/pipelines/publish', fetchOptions)
}
